module.exports = __webpack_public_path__ + "static/img/krungsri-auto-logo-2.20f3516.svg";